<app-spinner></app-spinner>
<div class="content">
  <div
    *ngIf="shown.grid"
    class="col-md-12 col-sm-12 col-xs-12 col-lg-12"
    style="padding: 10px;"
  >
    <mat-card style="margin-bottom: 10px; padding: 5px;">
      <mat-form-field appearance="outline" style="width: 30%;">
        <mat-label>Search Attribute</mat-label>
        <input
          matInput
          type="text"
          (keyup)="attributeFilter($event.target.value)"
        />
      </mat-form-field>
      <div
        style="float: right; padding: 10px; cursor: pointer;"
        mat-raised-button
        matTooltip="Add"
        matTooltipPosition="left"
        color="blue "
        class=" "
        (click)="AttributeForm()"
        mat-flat-button
      >
        <img src="assets/img/icons/group-31.png " />
      </div>
    </mat-card>

    <mat-card>
      <table
        mat-table
        matSort
        [dataSource]="dataSource"
        class="mat-elevation-z8"
        style="width: 100%;"
      >
        <!--- Note that these columns can be defined in any order.
        The actual rendered columns are set as a property on the row definition" -->

        <ng-container matColumnDef="Id">
          <th mat-header-cell *matHeaderCellDef>Id</th>
          <td mat-cell *matCellDef="let element">{{ element.attributeId }}</td>
        </ng-container>

        <ng-container matColumnDef="Sno">
          <th mat-header-cell *matHeaderCellDef>S.No</th>
          <td mat-cell *matCellDef="let element">
            {{ dataSource.filteredData.indexOf(element) + 1 }}
          </td>
        </ng-container>

        <ng-container matColumnDef="entityType">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Entity</th>
          <td mat-cell *matCellDef="let element">{{ element.entityType }}</td>
        </ng-container>

        <!-- Position Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
          <td mat-cell *matCellDef="let element">{{ element.name }}</td>
        </ng-container>

        <ng-container matColumnDef="edit">
          <th mat-header-cell *matHeaderCellDef>Edit</th>
          <td
            mat-cell
            *matCellDef="let element"
            class="pointer"
            
           
          >
            <img src="assets/img/icons/forma-1-copy-2.png "  matTooltip="Edit"
            matTooltipPosition="left" (click)="editAttribute(element.attributeId)" />
          </td>
        </ng-container>

        <ng-container matColumnDef="delete">
          <th mat-header-cell *matHeaderCellDef>Delete</th>
          <td
            mat-cell
            *matCellDef="let element; let i = index"
            class="pointer"
          >
            <img src="assets/img/icons/forma-1.png "   matTooltip="Delete"
            matTooltipPosition="left" (click)="deleteAttribute(element.attributeId)" />
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      <mat-paginator
        [pageSizeOptions]="[10, 20, 100]"
        showFirstLastButtons
        [pageIndex]="pageIndex"
        [pageSize]="pageSize"
        (page)="handlePage($event)"
      ></mat-paginator>
    </mat-card>
  </div>

  <!-- Form Begin -->
  <div *ngIf="shown.Form">
    <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12" style="padding: 10px;">
      <mat-card class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
        <mat-card-header>
          <mat-card-title>
            <div class="backcontainer">
              <div
                class="Back"
                (click)="backattributeList()"
                matTooltip="Back"
                matTooltipPosition="left"
              >
                <img src="assets/img/icons/shape-1.png" /> <span>Back</span>
              </div>
            </div>
            <div *ngIf="!this.Attribute.value.attributeId" class="headLabel">
              Add Attribute
            </div>
            
            <div *ngIf="this.Attribute.value.attributeId" class="headLabel">
              Edit Attribute
            </div>
          </mat-card-title>
        </mat-card-header>

        <form [formGroup]="Attribute" class="example-form">
          <!--  <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
                        <div class="col-sm-12 col-xs-12 col-md-2 col-lg-2 flabel">Entity:</div>
                        <div class="col-sm-12 col-xs-12 col-md-4 col-lg-4">
                            <mat-form-field appearance="outline" class="example-full-width" style="width:100%">
                                <input matInput placeholder="" formControlName="entityType" value="">
                            </mat-form-field>
                        </div>
                    </div> -->

          <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
            <div class="col-sm-12 col-xs-12 col-md-2 col-lg-2 flabel">
              Entity: *
            </div>
            <div class="col-sm-12 col-xs-12 col-md-4 col-lg-4">
              <mat-form-field appearance="outline" style="width: 100%;">
                <mat-label>Input Entities</mat-label>
                <mat-select disableRipple formControlName="entityType">
                  <mat-option
                    *ngFor="let entity of entity"
                    [value]="entity.name"
                  >
                    {{ entity.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <!--  <div class="col-sm-12 col-xs-12 col-md-6 col-lg-6">
							<mat-form-field appearance="outline" style="width:100%">
 							<mat-label>Input Entities</mat-label> <mat-select disableRipple
								formControlName="entityType"> <mat-option
								*ngFor="let entity of entity" [value]="entity.name">
							{{entity.name}} </mat-option> </mat-select> </mat-form-field>
						</div> -->

          <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
            <div class="col-sm-12 col-xs-12 col-md-2 col-lg-2 flabel">
              Unique Name: *
            </div>
            <div class="col-sm-12 col-xs-12 col-md-4 col-lg-4">
              <mat-form-field
                appearance="outline"
                class="example-full-width"
                style="width: 100%;"
              >
                <input
                  (keypress)="handleInput($event)"
                  matInput
                  placeholder=""
                  formControlName="name"
                  value=""
                />
              </mat-form-field>
              <mat-error *ngIf="validator.UniqueAttribute">{{
                validator.errorMessage
              }}</mat-error>
            </div>
          </div>

          <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
            <div class="col-sm-12 col-xs-12 col-md-2 col-lg-2 flabel">
              UI Name:
            </div>
            <div class="col-sm-12 col-xs-12 col-md-4 col-lg-4">
              <mat-form-field
                appearance="outline"
                class="example-full-width"
                style="width: 100%;"
              >
                <input
                  matInput
                  placeholder=""
                  formControlName="uiName"
                  value=""
                />
              </mat-form-field>
            </div>
          </div>

          <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
            <mat-checkbox class="flabel" formControlName="isShowInfo"
              >Info Hightlights/Highlighted</mat-checkbox
            >
          </div>
          <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
            <mat-checkbox class="flabel" formControlName="isShowAlgo"
              >Show Consider algorithm</mat-checkbox
            >
          </div>
          <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
            <mat-checkbox class="flabel" formControlName="isUnique"
              >Unique</mat-checkbox
            >
          </div>
          <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
            <mat-checkbox class="flabel" formControlName="isCustom"
              >Show in custom UI</mat-checkbox
            >
          </div>

          <div
            *ngIf="Attribute.value.isShowAlgo"
            class="col-sm-12 col-xs-12 col-md-12 col-lg-12"
          >
            <div class="col-sm-12 col-xs-12 col-md-2 col-lg-2 flabel">
              Correlation value:
            </div>
            <div class="col-sm-12 col-xs-12 col-md-4 col-lg-4">
              <mat-form-field
                appearance="outline"
                class="example-full-width"
                style="width: 95%;"
              >
                <input
                  matInput
                  placeholder=""
                  type="text"
                  (keypress)="numberOnly($event)"
                  formControlName="correlationValue"
                />
              </mat-form-field>
              <span> %</span>

              <mat-error *ngIf="validator.isCorrelation"
                >This Field is required</mat-error
              >
            </div>
          </div>
          <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
            <div class="col-sm-12 col-xs-12 col-md-2 col-lg-2"></div>
            <div class="col-sm-12 col-xs-12 col-md-4 col-lg-4">
              <button
                [disabled]="!Attribute.valid"
                style="width: 100%;"
                mat-flat-button
                class="btn"
                (click)="createAttribute()"
              >
                Add
              </button>
            </div>
          </div>
        </form>
      </mat-card>
    </div>
  </div>
</div>
